import React from 'react';
import OwlCarousel from 'react-owl-carousel3';
import ProductBox from '../home/ProductBox';
import PropTypes from 'prop-types';
import {liefershops} from '../../utils.js';


class CategoriesCarousel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            activeId: null,
        };
    }

    componentDidMount() {
        fetch(liefershops('api/v1/specialties/'))
            .then((response) => response.json())
            .then((data) => {
                this.setState({data: data, loading: false});
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({loading: false});
            });
    }

    handleItemClick = (id) => {
        // Якщо натиснули на той самий елемент, скидаємо фільтр
        this.setState((prevState) => ({
            activeId: prevState.activeId === id ? null : id,
        }));
    };

    render() {
        const {data, loading, activeId} = this.state;

        const filteredData = activeId ? data.filter(item => item.id === activeId) : data;

        if (loading) {
            return <div>Loading...</div>;
        }

        return (
            <OwlCarousel nav loop {...options} className="owl-carousel-category owl-theme">
                {filteredData.map((item) => {
                    // const {name, image} = item;
                    return (
                        <div className="item" key={item.id} onClick={() => this.handleItemClick(item.id)}>
                            <ProductBox
                                boxClass='osahan-category-item'
                                title={item.name}
                                image={item.image}
                                imageClass='img-fluid'
                                imageAlt={item.name}
                                onClick={this.props.onSpecialityChange}
                            />
                        </div>
                    );
                })}

                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Chinesische Spezialitäten'*/}
                {/*        image='img/list/chinesische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Chinesische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Griechische Spezialitäten'*/}
                {/*        image='img/list/griechische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Griechische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*/!* <div className="item">*/}
                {/*	<ProductBox */}
                {/*		boxClass='osahan-category-item'*/}
                {/*		title='Chinese'*/}
                {/*		counting='111'*/}
                {/*		image='img/list/5.png'*/}
                {/*		imageClass='img-fluid'*/}
                {/*		imageAlt='carousel'*/}
                {/*		onClick={this.props.onSpecialityChange}*/}
                {/*	/>*/}
                {/*</div> *!/*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Grill Spezialitäten'*/}
                {/*        image='img/list/grill_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Grill Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Indische Spezialitäten'*/}
                {/*        image='img/list/indische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Indische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Italienische Spezialitäten'*/}
                {/*        image='img/list/italienische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Italienische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Japanische Spezialitäten'*/}
                {/*        image='img/list/japanische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Japanische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Mexikanische Spezialitäten'*/}
                {/*        image='img/list/mexikanische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Mexikanische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Pakistanische Spezialitäten'*/}
                {/*        image='img/list/pakistanische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Pakistanische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Thailändische Spezialitäten'*/}
                {/*        image='img/list/thailaendische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Thailändische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Vietnamesische Spezialitäten'*/}
                {/*        image='img/list/vietnamesische_spezialitaeten.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Vietnamesische Spezialitäten'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="item">*/}
                {/*    <ProductBox*/}
                {/*        boxClass='osahan-category-item'*/}
                {/*        title='Spezialitäten der Welt'*/}
                {/*        image='img/list/spezialitaeten_der_welt.png'*/}
                {/*        imageClass='img-fluid'*/}
                {/*        imageAlt='Spezialitäten der Welt'*/}
                {/*        onClick={this.props.onSpecialityChange}*/}
                {/*    />*/}
                {/*</div>*/}
            </OwlCarousel>
        );
    }
}

const options = {
    responsive: {
        0: {
            items: 3,
        },
        600: {
            items: 4,
        },
        800: {
            items: 6,
        },
        1000: {
            items: 7,
        },
        1200: {
            items: 8,
        },
    },
    loop: false,
    rewind: true,
    lazyLoad: true,
    autoplay: true,
    dots: false,
    autoplaySpeed: 700,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
}

CategoriesCarousel.propTypes = {
    onSpecialityChange: PropTypes.func.isRequired
};
CategoriesCarousel.defaultProps = {
    onSpecialityChange: () => {
    }
}

export default CategoriesCarousel;